import Immutable from 'immutable';

export interface RawColor {
  space: string; // set this up with an enum
  components: number[];
}

export interface ColorData {
  space: string;
  components: Immutable.List<number>;
}

const defaultValues: ColorData = {
  space: 'rgb',
  components: Immutable.List<number>(),
};

export const ColorFactory = Immutable.Record(defaultValues, 'Color');

export class Color extends ColorFactory {
  static deserialize(rawColor: RawColor): Color {
    return new Color({
      ...rawColor,
      components: Immutable.List(rawColor.components),
    });
  }

  static fromRGB(r: number, g: number, b: number): Color {
    return new Color({
      space: 'rgb',
      components: Immutable.List<number>([r, g, b]),
    });
  }

  serialize(): RawColor {
    return this.toJS();
  }

  get r(): number {
    return this.components.get(0, 0);
  }

  get g(): number {
    return this.components.get(1, 0);
  }

  get b(): number {
    return this.components.get(2, 0);
  }
}
